/* eslint quotes: "off" */

export const spinTheWheel = (clicks, degree, num) => {
  //add 1 every click
  clicks++;

  /*multiply the degree by number of clicks
   generate random number between 1 - 360,
   then add to the new degree*/
  let newDegree = degree * clicks;
  let extraDegree = Math.floor(((6 - (num + 1)) * (1 / 6) + (1 / 6)) * (360 - 1 + 1)) + 1 + 30;
  let totalDegree = newDegree + extraDegree;

  $("#inner-wheel")
    .css({
      '-webkit-transition': 'all 6s cubic-bezier(0, .99, .44, .99)',
      '-moz-transition': 'all 6s cubic-bezier(0, .99, .44, .99)',
      'o-transition': 'all 6s cubic-bezier(0, .99, .44, .99)',
      'ms-transition': 'all 6s cubic-bezier(0, .99, .44, .99)',
      'transition': 'all 6s cubic-bezier(0, .99, .44, .99)'
    });

  /*let's make the spin btn to tilt every
   time the edge of the section hits
   the indicator*/
  $('#wheel .sec').each(function () {
    let t = $(this);
    let c = 0;
    let n = 700;
    const interval = setInterval(function () {
      c++;
      if (c === n) {
        clearInterval(interval);
      }
      let aoY = t.offset().top;
      $("#txt").html(aoY);

      /*23.7 is the minumum offset number that
       each section can get, in a 30 angle degree.
       So, if the offset reaches 23.7, then we know
       that it has a 30 degree angle and therefore,
       exactly aligned with the spin btn*/
      if (aoY < 23.89) {
        $('#spin').addClass('spin');
        setTimeout(function () {
          $('#spin').removeClass('spin');
        }, 100);
      }
    }, 10);
    $('#inner-wheel').css({
      'transform': 'rotate(' + totalDegree + 'deg)'
    });
  });
  return clicks;
};

export const stopSpinningTheWheel = () => {
  const wheel = $('#inner-wheel');
  const e = wheel.css('transform'); // get the current state
  wheel.css('transform', e);
};


export const resetWheelPosition = () => {
  $('#inner-wheel')
    .css({
      '-webkit-transition': '',
      '-moz-transition': '',
      'o-transition': '',
      'ms-transition': '',
      'transition': ''
    }).css({'transform': ''})
};



// WEBPACK FOOTER //
// ./src/common/jQuery.js